import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Vacation } from '../../types/team.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { CreateVacationDto } from './use-create-vacation';

export type UpdateVacationDto = Partial<CreateVacationDto>;

// Cross-tenant admin data — not scoped to companies/:companyId; enforced server-side by AdminPanelGuard.
export const useUpdateVacation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateVacation, isPending } = useAppMutation([QueryKey.UPDATE_VACATION], {
    mutationFn: ({ id, ...body }: { id: string } & UpdateVacationDto) =>
      ApiService.patch<Vacation, UpdateVacationDto>(
        { endpoint: BackendRoute.TEAM_VACATIONS, routePath: [id] },
        { body },
      ),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QueryKey.GET_VACATIONS] }),
  });

  return { updateVacation, isPending };
};
